import { AddGiftCardModal } from 'components/gift-card-modal/add-gift-card';
import { usePaymentCheckoutRedesignExperiment } from 'experiments/use-payment-checkout-redesign-experiment';
import { AddGiftCardRedesign } from 'pages/cart/payment/order-payment/add-gift-card-redesign/add-gift-card-redesign';

export default function AddGiftCard() {
  const isPaymentRedesignEnabled = usePaymentCheckoutRedesignExperiment();

  return isPaymentRedesignEnabled ? <AddGiftCardRedesign /> : <AddGiftCardModal />;
}
